export interface FamilyMember {
  id: string
  firstName: string
  lastName: string
  role: string
  initials: string
  hasCard: boolean
  photo: string
  canEdit: boolean
}

export interface EditableField {
  id: string
  label: string
  placeholder: string
  requiresProof: boolean
  proofLabel?: string
}

export const editableFields: EditableField[] = [
  {
    id: 'prenom',
    label: 'Prénom',
    placeholder: 'Charlotte',
    requiresProof: true,
    proofLabel: 'Certificat de naissance ou pièce d’identité',
  },
  {
    id: 'nom',
    label: 'Nom de famille',
    placeholder: 'Bouchard',
    requiresProof: true,
    proofLabel: 'Pièce d’identité officielle',
  },
  { id: 'genre', label: 'Genre', placeholder: 'Femme', requiresProof: false },
  { id: 'photo', label: 'Photo de la carte', placeholder: 'Nouvelle photo', requiresProof: false },
  {
    id: 'adresse',
    label: 'Adresse',
    placeholder: '112, route 138, Baie-Trinité',
    requiresProof: false,
    proofLabel: 'Preuve de résidence (bail, compte de taxes, permis de conduire)',
  },
]

export const verifiedAddresses = [
  { id: 'route-138', label: '112, route 138, Baie-Trinité', note: 'Adresse principale · vérifiée' },
  {
    id: 'pointe-des-monts',
    label: 'Chemin du Vieux-Phare, Pointe-des-Monts',
    note: 'Bail de villégiature · vérifié',
  },
]

export const memberValues: Record<string, Record<string, string>> = {
  charlotte: {
    prenom: 'Charlotte',
    nom: 'Bouchard',
    genre: 'Femme',
    photo: 'Photo actuelle',
    adresse: '112, route 138, Baie-Trinité',
  },
  marc: {
    prenom: 'Marc',
    nom: 'Bélanger',
    genre: 'Homme',
    photo: 'Photo actuelle',
    adresse: '112, route 138, Baie-Trinité',
  },
  emma: {
    prenom: 'Emma',
    nom: 'Bouchard',
    genre: 'Femme',
    photo: 'Photo actuelle',
    adresse: '112, route 138, Baie-Trinité',
  },
}

export const citizen = {
  firstName: 'Charlotte',
  lastName: 'Bouchard',
  initials: 'CB',
  city: 'Baie-Trinité',
}

export const cardCredentials = ['Résident', 'Centre de tri', 'Bibliothèque', 'Villégiature']

export interface WalletCard {
  id: string
  label: string
  number: string
  badge: string
  note: string
}

export const walletCards: WalletCard[] = [
  {
    id: 'citoyenne',
    label: 'Carte numérique',
    number: '0040327823',
    badge: 'Résident',
    note: 'Preuve de résidence à l’entrée du centre de tri',
  },
  {
    id: 'loisirs',
    label: 'Loisirs',
    number: '0093612477',
    badge: 'Résident',
    note: 'Réservation de la salle communautaire',
  },
  {
    id: 'bibliotheque',
    label: 'Bibliothèque',
    number: '0071845209',
    badge: 'Résident',
    note: '2 documents à rapporter avant le 26 septembre',
  },
]

export const familyMembers: FamilyMember[] = [
  {
    id: 'charlotte',
    firstName: 'Charlotte',
    lastName: 'Bouchard',
    role: 'Titulaire',
    initials: 'CB',
    hasCard: true,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/3ed6e46d-2ab5-4f53-8f0e-9919328bc5b5.jpg',
    canEdit: true,
  },
  {
    id: 'marc',
    firstName: 'Marc',
    lastName: 'Bélanger',
    role: 'Conjoint',
    initials: 'MB',
    hasCard: true,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/6d75bf83-2bf9-4f1d-8912-8fecf05ffaa8.jpg',
    canEdit: false,
  },
  {
    id: 'emma',
    firstName: 'Emma',
    lastName: 'Bouchard',
    role: 'Enfant',
    initials: 'EB',
    hasCard: false,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/34fafd9b-c877-4154-8e6b-5e158dfa521f.jpg',
    canEdit: true,
  },
]
